<template>
    <div class="container lnb d_container">
        <div class="contents_wrap">
            <div class="contents list-container">
                <div class="title">
                    1:1문의상세정보
                </div>
                <board-write-component :boardType="'qnaCreate'" :boardKey="boardKey"></board-write-component>
                <div class="pa15 text-center btn_wrap">
                    <el-button type="save" @click="save">저장</el-button>
                    <el-button type="cancel" @click="backEvent()" :disabled="disableBtn">목록</el-button>
                </div>
            </div>
            <div class="footer-copyright">Copyright 2021. Peopleandtalk co.,Ltd. All rights reserved</div>
        </div>
    </div>
</template>

<script>
    import BoardWriteComponent from "@/components/board/BoardWriteComponent";
    import EventBus from "@/utils/event-bus";
    export default {
        name: "QnaCreate",
        mixins: [],
        components: {BoardWriteComponent},
        provide() {
            return {}
        },
        props: {},
        data() {
            return {
                boardKey: this.$route.params.idx,
                disableBtn: false,
            }
        },
        created() {
        },
        mounted() {
        },
        beforeDestroy() {
        },
        destroyed() {
        },
        computed: {},
        methods: {
            save() {
                EventBus.$emit('writeBoard');
            },
            backEvent() {
                this.disableBtn= true
                this.$router.back()
            },
        },
        watch: {},
    }
</script>

<style scoped>

</style>